// Animation d'ouverture / fermeture des accordéons de la fiche produit
// (description, livraison, avis...). Délégation sur document pour continuer
// à fonctionner quand la section est re-rendue au changement de variante.
(function () {
  if (window.productAccordionAnimationLoaded) return;
  window.productAccordionAnimationLoaded = true;

  const DURATION = 300;
  const EASING = 'cubic-bezier(0.22, 0.61, 0.36, 1)';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function animate(details, opening) {
    const summary = details.querySelector(':scope > summary');
    const startHeight = details.offsetHeight;

    if (details._accordionAnimation) details._accordionAnimation.cancel();
    details.style.overflow = 'hidden';

    let endHeight;
    if (opening) {
      details.classList.remove('is-closing');
      details.open = true;
      endHeight = details.offsetHeight;
    } else {
      // Bascule l'icône +/- tout de suite, sans attendre la fin de l'animation
      details.classList.add('is-closing');
      endHeight = summary.offsetHeight;
    }

    const animation = details.animate(
      { height: [`${startHeight}px`, `${endHeight}px`] },
      { duration: DURATION, easing: EASING }
    );
    details._accordionAnimation = animation;

    const content = details.querySelector(':scope > .accordion__content');
    if (content) {
      content.animate(
        { opacity: opening ? [0, 1] : [1, 0] },
        { duration: DURATION, easing: EASING }
      );
    }

    animation.onfinish = () => {
      if (!opening) details.open = false;
      details.classList.remove('is-closing');
      details.style.overflow = '';
      details._accordionAnimation = null;
    };
    animation.oncancel = () => {
      details.style.overflow = '';
    };
  }

  document.addEventListener('click', (event) => {
    const summary = event.target.closest('.product__accordion details > summary');
    if (!summary || reducedMotion.matches || typeof Element.prototype.animate !== 'function') return;

    const details = summary.parentElement;
    event.preventDefault();

    const isClosing = details.classList.contains('is-closing');
    animate(details, !details.open || isClosing);
  });
})();
